export function isNotUndefined(argument) {
    return argument !== undefined;
}
